import CommentMessage from './CommentMessage';

export default CommentMessage;
